import React, { useEffect } from "react";
import { connect } from "react-redux";

import * as DriverBannerActions from "../../../store/actions/DriverBanner";

import { bindActionCreators } from "redux";
import { useLocation } from "react-router-dom";
import TargetAudienceForm from "../TargetAudienceForm";

const BannerTargetAudience = (props) => {
  const { getTargetableBusiness, targetAudience, targetableBusiness, isLoading } = props;
  const query = new URLSearchParams(useLocation()?.search);
  const userAction = query.get("action");
  const bannerId = query.get("id");

  useEffect(() => {
    if (bannerId) {
      // to fetch the list of banner target audience
      getTargetableBusiness();
    }
  }, []);

  return (
    <TargetAudienceForm targetAudienceList={targetAudience} userAction={userAction} targetableBusiness={targetableBusiness} isApiLoading={isLoading} />
  );
};

function mapStateToProps(state) {
  const { User, DriverBanner } = state;
  
  return {
    targetAudience: DriverBanner?.targetAudience,
    targetableBusiness: DriverBanner?.targetableBusiness,
    isLoading: User.isLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getTargetAudience: bindActionCreators(
      DriverBannerActions.getBannerTargetAudience,
      dispatch
    ),
    getTargetableBusiness: bindActionCreators(
      DriverBannerActions.getTargetableBusiness,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BannerTargetAudience);
